import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from 'services/AuthService';
import routes from 'store/configs/Routes';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FunctionComponent<ProtectedRouteProps> = ({ children }) => {
  return AuthService.isAuthenticated() ? <>{children}</> : <Navigate to={routes.login} data-testid={'redirect'} />;
};
export default ProtectedRoute;
